module.exports = __webpack_public_path__ + "img/视频.f4342798.svg";